import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ExecucaoOrcamentaria, ExecucaoOrcamentariaAlterar, ExecucaoOrcamentariaPrevisaoLiquidacao } from '../../models/execucao-orcamentaria.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-edit',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-edit.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-edit.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaEditComponent extends BaseFormComponent<ExecucaoOrcamentaria> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  list: any;
  totaisPorExecucao: ExecucaoOrcamentaria[];
  totais: any;
  execucaoPrevisaoList: ExecucaoOrcamentariaPrevisaoLiquidacao[];
  totais_execucaoPrevisaoList: any;
  total_projeto: any;
  formPrevisao: FormGroup;
  warnings: any[];
  permission: any;
  modalRef?: BsModalRef;
  execucaoAlterar: ExecucaoOrcamentariaAlterar;
  audit: AtualizacoesAudit;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    private myService: ExecucaoOrcamentariaService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private modalService: BsModalService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initForm();
      this.initList();
      this.audit = {
        budget_table_id: this.idProjeto
      };
    });
  }

  initList() {
    this.loading();
    this.addSub(
      this.myService.getById(this.idProjeto).subscribe({
        next: (res) => {
          this.totaisPorExecucao = res['totaisPorExecucao'];
          this.totais = res['totais'];
          this.execucaoPrevisaoList = res['execucaoPrevisaoList'];
          this.totais_execucaoPrevisaoList = res['totais_execucaoPrevisaoList'];
          this.total_projeto = res['total_projeto'];
          this.warnings = res['warnings'];
          this.permission = res['permission'];
          if (this.totaisPorExecucao?.length) {
            this.getFormArray().clear();
            this.totaisPorExecucao?.forEach((item) => {
              this.getFormArray().push(this.createFormGroup(item))
            })
          }
          if (this.execucaoPrevisaoList?.length) {
            this.getFormArrayPrevisao().clear();
            this.execucaoPrevisaoList?.forEach((item) => {
              this.getFormArrayPrevisao().push(this.createFormGroupPrevisao(item))
            })
          }
          this.loaded();
        },
        error: (err) => { 
          this.msgError(err?.error?.message);
          this.loaded();
        },
      })
    )
  }

  initForm() {
    this.form = new FormGroup({
      execucao: new FormArray([]),
    });

    this.formPrevisao = new FormGroup({
      previsao: new FormArray([]),
    });
  }

  createFormGroup(value = null): FormGroup {
    return new FormGroup({
      id: new FormControl(value?.id),
      ano_exercicio: new FormControl(value?.ano_exercicio),
      valor_planejado: new FormControl(this.formatNumberForDisplay(value?.valor_planejado)),
    });
  }

  createFormGroupPrevisao(value = null): FormGroup {
    return new FormGroup({
      id: new FormControl(value?.id),
      ano_exercicio: new FormControl(value?.ano_exercicio),
      total_planejado: new FormControl(this.formatNumberForDisplay(value?.total_planejado)),
      previsao_loa: new FormControl(this.formatNumberForDisplay(value?.previsao_loa)),
      nova_previsao: new FormControl(this.formatNumberForDisplay(value?.nova_previsao)),
      liquidado: new FormControl(this.formatNumberForDisplay(value?.liquidado)),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('execucao') as FormArray;
  }

  getFormArrayPrevisao(): FormArray {
    return this.formPrevisao.get('previsao') as FormArray;
  }

  view(id: number) {
    return ['/projetos', 'projeto', this.idProjeto, 'execucao-orcamentaria', id];
  }

  formatNumberForDisplay(value: number | string): string {
    const num = Number(value);
    if (isNaN(num)) return '';
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  getDataCreate(): any {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    if (this.permission?.viewExec) {
      data = Object.assign({}, data, this.formPrevisao.value);
    }
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.totaisPorExecucao?.length || this.execucaoPrevisaoList) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.idProjeto).subscribe({
            next: (res) => {
              this.confirmation('Execução Orçamentária alterada com sucesso!').subscribe(() => {
                EventSharedService.get('auditRefresh').emit();
                this.initList();
              });
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
      this.getFormArray().controls.forEach((form, index) => {
        Object.keys(form['controls']).forEach((key) => this.getFormArray().controls[index]['controls'][key].markAsDirty())
      })
    }
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  formatarMedidaFisica(index: number, field: string, previsao = false) {
    let form = previsao ? this.getFormArrayPrevisao() : this.getFormArray();
    let goalValue = form.controls[index].get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, 2);
    form.controls[index].get(field).setValue(value);

    this.atualizaTotal();
  }

  atualizaTotal() {
    let form = this.getFormArray();
    let total = 0;
    form.controls.forEach(control => {
      total += this.parseNumberFromDisplay(control.get('valor_planejado').value);
    });
    this.totais.valor_planejado = total;

    if (this.permission?.viewExec) {
      let formPrevisao = this.getFormArrayPrevisao();
      let total_previsao = {
        total_planejado: 0,
        previsao_loa: 0,
        nova_previsao: 0,
        liquidado: 0
      };
      formPrevisao.controls.forEach(control => {
        total_previsao.total_planejado += this.parseNumberFromDisplay(control.get('total_planejado').value);
        total_previsao.previsao_loa += this.parseNumberFromDisplay(control.get('previsao_loa').value);
        total_previsao.nova_previsao += this.parseNumberFromDisplay(control.get('nova_previsao').value);
        total_previsao.liquidado += this.parseNumberFromDisplay(control.get('liquidado').value);
      });
      this.totais_execucaoPrevisaoList = total_previsao;
      this.total_projeto.total_previsto = total_previsao.nova_previsao + total_previsao.liquidado; // sim é nova_previsao (replanned + done da modelagem antiga)
    }
  }

	parseNumberFromDisplay(value: string): number {
		if (!value) return 0;
		// Remove os pontos de milhar e troca a vírgula decimal por ponto
		const cleaned = value.replace(/\./g, '').replace(',', '.');
		const num = parseFloat(cleaned);
		return isNaN(num) ? 0 : num;
	}

  openModal() {
    this.execucaoAlterar = {
      year_ini: this.totaisPorExecucao?.length ? this.totaisPorExecucao[0]?.ano_exercicio : null,
      year_end: this.totaisPorExecucao?.length ? this.totaisPorExecucao[this.totaisPorExecucao?.length - 1]?.ano_exercicio : null
    }
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.modalRef?.hide();
  }

  gerar() {
    if (Number(this.execucaoAlterar?.year_end) >= Number(this.execucaoAlterar?.year_ini)) {
      this.loading();
      this.execucaoAlterar.erroText = '';
      this.closeModal();
      this.addSub(
        this.myService.alterAno(this.execucaoAlterar, this.idProjeto).subscribe({
          next: (res) => {
            this.confirmation().subscribe(() => {
              this.initList();
            });
            this.loaded();
            EventSharedService.get('auditRefresh').emit();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
    else {
      this.execucaoAlterar.erroText = 'O término da tabela não pode ser inferior ao início da tabela.';
    }
  }

  maskNumber(event) {
    event.target.value = event.target.value.replace(/\D/i, '');
  }

  cleanValue(index: number, field: string, fieldClean) {
    this.getFormArrayPrevisao().controls[index].get(fieldClean).setValue('');
    let value = this.getFormArrayPrevisao().controls[index].get(field)?.value;
  }

  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event']) onCtrlS(event: KeyboardEvent): void {
    event.preventDefault();
    this.salvar();
  }
  //detecta se o formulário está manipulado e se  pessoa está atualizando a página ou saindo dela.
  @HostListener('window:beforeunload', ['$event']) onBeforeUnload($event: BeforeUnloadEvent): void {
    $event.preventDefault();
  }

}
